export default __webpack_public_path__ + "static/media/privlo-new-min.33b575d6.jpg";